
export default {
  props: ["item", "stacked"],
  data() {
    return {
      threshold: this.$store.getters.store.eshop?.var?.threshold || 0.5,
      pool: {
      "blackfriday": {
          color: "",
          text: "",
          icon: "badge_blackfriday",
          label: "",
          weight: 0.9,
          height:"20px",
          padding:"0"
        },
        "pharmacist": {
          color: "#165c3a",
          text: "#fff",
          icon: "",
          label: "ΕΠΙΛΟΓΗ ΦΑΡΜΑΚΟΠΟΙΟΥ",
          weight: 1,
        },
        "295choice": {
          color: "#FFED00",
          text: "#111",
          icon: "badge_295choice",
          label: "295 Choice",
          weight: 0.8,
        },
        best_seller: {
          color: "#EBEBEB",
          text: "#111",
          icon: "badge_bestseller",
          label: "Best Seller",
          weight: 0.5,
        },
        best_category: {
          color: "#EBEBEB",
          text: "#111",
          icon: "badge_bestcategory",
          label: "Best in category",
          weight: 0.6,
        },
        best_brand: {
          color: "#EBEBEB",
          text: "#111",
          icon: "badge_bestbrand",
          label: "Best in brand",
          weight: 0.5,
        },
        price_drop: {
          color: "#FFED00",
          text: "#111",
          icon: "badge_pricedrop",
          label: "Πτώση τιμής",
          weight: 1,
        },
        top_price: {
          color: "#FFED00",
          text: "#111",
          icon: "badge_topprice",
          label: "Top Tiμή",
          weight: 0.7,
        },
        profit: {
          color: "#FFED00",
          text: "#111",
          icon: "badge_profit",
          label: "Όφελος @@@@€",
          weight: 1,
        },
        save: {
          color: "#FFED00",
          text: "#111",
          icon: "badge_discount",
          label: "Κερδίζεις -@@@@%",
          weight: 1,
        },
        promo_tag: {
          color: "#EEE8F4",
          text: "#1E4999",
          icon: "badge_promo",
          label: "295 Choice",
          weight: 0.9,
        },
      },
      icons: {},
      values: [],
    };
  },
  methods: {},
  created() {
    let badge_history = [];
    let now = Date.now();
    let promoValues = Object.keys(this.item?.promos || {}).reduce((acc, _) => {
      if ((this.item.promos[_].variables + "" || "").includes("smartbuy")) {
        let v = this.item.promos[_];
        try {
          if (v.from && new Date(v.from).getTime() > Date.now()) {
            return acc;
          }
          if (v.to && new Date(v.to).getTime() < Date.now()) {
            return acc;
          }
        } catch (e) {}
        v.tags?.forEach((t) => {
          if (badge_history.includes(t)) {
            return;
          }
          badge_history.push(t);
          acc.push({
            color: "#EEE8F4",
            text: "#1E4999",
            icon: "badge_promo",
            label: t,
            weight: 0.9,
          });
        });
      }
      return acc;
    }, []);
    let values = [];
    if (
      this.item.prices.profit &&
      parseFloat(this.item.prices.profit) > parseFloat(this.threshold) &&
      this.$hyperItem.categoryCheck(this.item)
    ) {
      values.push(this.pool.price_drop);
    }
    // if(this.item.prices.discount){
    //   this.pool.save.label = this.pool.save.label.replace("@@@@", this.item.prices.discount);
    //   values.push(this.pool.save);
    // }
    if (this.item.flat_tags["295choice"]) {
      values.push(this.pool["295choice"]);
    }
   
    //if (this.item.flat_tags["Προσφορά"] == "Special Offer") {
    //  values.push(this.pool.blackfriday);
    //}
    if (this.item.flat_tags.best_seller) {
      values.push(this.pool.best_seller);
    }
    if (this.item.flat_tags.best_family) {
      values.push(this.pool.best_category);
    }
    if (this.item.flat_tags.best_manufacturer) {
      values.push(this.pool.best_brand);
    }
    if(this.item.flat_tags?.["Προτάσεις"] == "Επιλογή Φαρμακοποιού"){ 
      values.push(this.pool.pharmacist);
    }
    if(this.item.tags.some(t=>(t.key+"").includes("Εκπτώσεις & Top Τιμές"))){
      const top_price = this.item.tags.find(t=>t.value && (t.value+"").includes("Πακέτα & Top Τιμές"));
      if(top_price){
        values.push(this.pool.top_price);
      }
      const last_pieces = this.item.tags.find(t=>t.value && (t.value+"").includes("Τελευταία Τεμάχια"));
        if(last_pieces){
          values.push({
            color: "#fed641",
            text: "#000",
            icon: "",
            label: "ΤΕΛΕΥΤΑΙΑ ΤΕΜΑΧΙΑ",
            weight: 1,
          }); 
    }
  }
    if (this.item?.adId) {
      values.push({
        color: "#EEE8F4",
        text: "#1E4999",
        label: "Διαφημιζόμενο",
        weight: 1,
      });
    }

    values = values.concat(promoValues);
    this.values = values.sort((a, b) => b.weight - a.weight).slice(0, 2);
  },
};
